import { stats } from '@/mocks/homeData';

const tickerItems = [
  '周五晚 · 正片名场面预警',
  '周末大瓜 · 双线线索待发酵',
  '月末盘点 · 热度数据采集中',
  '季度压轴 · 年度候选浮出水面',
  '周一见 · 下轮定档预告',
  '路透 vs 正片 · 新梗解析',
];

const upcoming = [
  { node: '周一见', when: '下周一 08:30', status: '已预约' },
  { node: '周五晚', when: '本周五 20:00', status: '本周主打', hot: true },
  { node: '周末大瓜', when: '本周六 10:00', status: '待蹲守' },
  { node: '月末盘点', when: '本月倒数第3天', status: '采集中' },
];

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      {/* decorative tints */}
      <div className="pointer-events-none absolute -right-40 -top-32 h-96 w-96 rounded-full bg-primary-100/60 blur-2xl" />
      <div className="pointer-events-none absolute -left-32 top-40 h-80 w-80 rounded-full bg-accent-100/70 blur-2xl" />

      <div className="relative mx-auto max-w-7xl px-4 pb-16 pt-28 md:px-6 md:pb-24 md:pt-40">
        <div className="flex flex-col gap-12 lg:flex-row lg:items-start lg:justify-between">
          {/* left: headline */}
          <div className="max-w-2xl lg:max-w-3xl">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-sm text-primary-700">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
              </span>
              蹲瓜时间表 · 全网按时打卡
            </div>

            <h1 className="font-heading text-4xl font-black leading-tight text-foreground-950 md:text-6xl md:leading-[1.08]">
              大瓜<span className="text-primary-600">预警</span>
              <span className="block mt-2 text-2xl font-bold text-foreground-800 md:text-4xl">
                周一到压轴，蹲瓜<span className="curl">不迷路</span>
              </span>
            </h1>

            <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
              我们把娱乐话题爆发的节奏整理成一张可预期的时间表：
              <span className="font-medium text-foreground-800">周一见、周五晚、周末大瓜、月末盘点、季度压轴</span>，
              每个节点都有新料更新。照表蹲守，第一落点、反转续集全都不错过。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
              <a
                href="#schedule"
                onClick={(e) => { e.preventDefault(); document.getElementById('schedule')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-base font-medium text-background-50 transition hover:bg-primary-600"
              >
                查看蹲瓜时间表
                <i className="ri-arrow-right-line" />
              </a>
              <a
                href="#subscribe"
                onClick={(e) => { e.preventDefault(); document.getElementById('subscribe')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-foreground-300 bg-transparent px-6 py-3 text-base font-medium text-foreground-800 transition hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
              >
                开启蹲守提醒
                <i className="ri-notification-3-line" />
              </a>
            </div>

            {/* stats */}
            <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-xl border border-background-200 bg-background-100/60 px-4 py-3">
                  <div className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">{s.value}</div>
                  <div className="mt-1 text-xs text-foreground-600 md:text-sm">{s.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* right: 蹲守预告单 */}
          <div className="w-full lg:max-w-md">
            <div className="overflow-hidden rounded-2xl border border-background-200 bg-background-50 shadow-[0_24px_60px_-40px_rgba(60,30,20,0.55)]">
              <div className="flex items-center justify-between bg-foreground-950 px-5 py-3.5 text-background-50">
                <span className="flex items-center gap-2 font-heading text-base font-bold">
                  <i className="ri-time-line" />
                  蹲守预告单
                </span>
                <span className="font-latin text-sm tracking-widest text-accent-300">LIVE</span>
              </div>
              <div className="divide-y divide-background-200">
                {upcoming.map((u) => (
                  <div key={u.node} className="flex items-center justify-between gap-3 px-5 py-3.5">
                    <div className="flex items-center gap-3">
                      <span className={`flex h-9 w-9 items-center justify-center rounded-lg text-sm ${u.hot ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-700'}`}>
                        <i className="ri-calendar-check-line" />
                      </span>
                      <div>
                        <div className="font-medium text-foreground-900">{u.node}</div>
                        <div className="text-xs text-foreground-500">{u.when}</div>
                      </div>
                    </div>
                    <span className={`whitespace-nowrap rounded-full px-2.5 py-1 text-xs ${u.hot ? 'bg-primary-100 text-primary-700' : 'bg-background-100 text-foreground-600'}`}>
                      {u.status}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <p className="mt-3 flex items-center gap-1.5 text-xs text-foreground-500">
              <i className="ri-information-line text-accent-500" />
              本季度压轴临近，提前订阅可在节点前收到话题预告。
            </p>
          </div>
        </div>
      </div>

      {/* ticker */}
      <div className="relative border-y border-foreground-950 bg-foreground-950 py-3 text-background-50">
        <div className="flex overflow-hidden">
          <div className="marquee-track flex shrink-0 items-center gap-8 pr-8">
            {[...tickerItems, ...tickerItems].map((t, i) => (
              <span key={i} className="flex shrink-0 items-center gap-8 whitespace-nowrap text-sm tracking-wide">
                {t}
                <i className="ri-fire-fill text-accent-400" />
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}